export const getWeb3Error = state => state.backend.web3Error
